/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Response for direct upload URL request
 */
export interface FileUploadUrlResponse {
  resourceId: string;
  uploadUrl: string;
  expiresIn: number;
}
